var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-detail-component"},[_c('market-view-live-detail-v5')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }